import {ReactElement} from 'react';

import {Container, Toolbar, AppBar, Box, Grid} from '@mui/material';

import {EmpionLogoWithText} from '../EmpionLogoWithText';

import {getAppHeaderWrapperSx} from '../../../layouts/theme/ThemeHelpers';

interface Props {
  children: ReactElement | ReactElement[];
  isTransparent?: boolean;
}

export const AppHeaderWrapper = ({children, isTransparent}: Props) => {
  const wrapperSx = getAppHeaderWrapperSx(isTransparent);

  return (
    <AppBar
      position='sticky'
      sx={{
        mt: '50px',
        ...wrapperSx,
        zIndex: 1000,
        borderRadius: '15px',
        height: '80px',
        marginBottom: '70px',
      }}
    >
      <Container maxWidth='lg' sx={{display: 'flex', flex: 1}}>
        <Toolbar disableGutters sx={{justifyContent: 'space-between', width: '100%'}}>
          <Box
            width={'100%'}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: 'row',
            }}
          >
            <EmpionLogoWithText />
            <Grid container justifyContent='flex-end' flexWrap='nowrap' alignItems='center' gap={1}>
              {children}
            </Grid>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
